import { WeblabId } from './weblab';

/**
 * Configuration map for marketplaces permitted to access the ungated SU Campus.
 *
 * Ungated campus is a Seller Central experience for unauthenticated prospective sellers.
 * Access is restricted to marketplaces where the experience has been validated,
 * localised content exists, and legal/compliance review is complete.
 *
 * Keys are lowercase marketplace country codes matching the `marketplaceCountryCode`
 * field returned by the seller-context API (e.g. "us", "ca").
 *
 * Values:
 *   - null  → unconditionally allowed (no weblab check required)
 *   - WeblabId → allowed only when the user is in T1 for that weblab.
 *               The weblab must be configured on the Mons route with:
 *               Id-Type: Session, Marketplace: Domain Default, Delivery Target: Frontend (HTML)
 *               This ensures treatment is resolved per-domain (not per Mons region),
 *               allowing individual marketplace dial-up without affecting the whole region.
 *
 * Background: The Mons route migration weblab (SP_SERVICES_SELLER_UNIVERSITY_UNGATED_CAMPUS_1395209)
 * operates at the Mons region level (NA = US + CA + MX + BR), so dialling up one marketplace
 * would expose all four. This map provides a secondary per-marketplace gate at the app layer.
 *
 * To add a marketplace without a weblab (fully launched):
 *   append: 'xx': null
 *
 * To add a marketplace behind a weblab (gradual rollout):
 *   append: 'xx': WeblabId.YourWeblabId
 *   Ensure the weblab is added to the Mons config for this route before deploying.
 */
export const UNGATED_CAMPUS_MARKETPLACE_CONFIG: Readonly<Record<string, WeblabId | null>> = {
  us: null,
  ca: null,
  mx: WeblabId.UngatedMarketplaces,
  br: WeblabId.UngatedMarketplaces,
  nl: WeblabId.UngatedMarketplaces,
  fr: WeblabId.UngatedMarketplaces,
  sa: WeblabId.UngatedMarketplaces,
  se: WeblabId.UngatedMarketplaces,
  ie: WeblabId.UngatedMarketplaces,
  in: WeblabId.UngatedMarketplaces,
  es: WeblabId.UngatedMarketplaces,
  eg: WeblabId.UngatedMarketplaces,
  sg: WeblabId.UngatedMarketplaces,
  pl: WeblabId.UngatedMarketplaces,
  ae: WeblabId.UngatedMarketplaces,
  de: WeblabId.UngatedMarketplaces,
  za: WeblabId.UngatedMarketplaces,
  tr: WeblabId.UngatedMarketplaces,
  gb: WeblabId.UngatedMarketplaces,
  it: WeblabId.UngatedMarketplaces,
  be: WeblabId.UngatedMarketplaces,
  jp: WeblabId.UngatedMarketplaces,
  au: WeblabId.UngatedMarketplaces,
};
